import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
		this.accordions = this.el.querySelectorAll('.c-nav-overlay__item.-lvl-0.-has-children');

		this.accordions.forEach((accordion) => {
			let accordionLink = accordion.querySelector('.c-nav-overlay__link');
		
			// Create a new button element
			let button = document.createElement('button');
			button.className = accordionLink.className; // Copy the class name
			button.innerHTML = accordionLink.innerHTML; // Copy the inner HTML
		
			// Replace the accordion link with the new button
			accordionLink.parentNode.replaceChild(button, accordionLink);
		
			// Add event listener to the new button
			button.addEventListener('click', (e) => {
				e.preventDefault();
				this.toggleAccordion(accordion);
			});
		});
    }

	toggleAccordion(accordion) {
		const isActive = accordion.classList.contains('is-open');
		this.accordions.forEach((accordion) => {
			accordion.classList.remove('is-open');
		});

		if (!isActive) {
			accordion.classList.add('is-open');
		}
	}

	destroy() {
		this.accordions.forEach((accordion) => {
			let accordionButton = accordion.querySelector('.c-nav-overlay__link');
			accordionButton.removeEventListener('click', this.toggleAccordion);
		});
	}
}
